import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {HttpModule} from '@angular/http';
import {FormsModule} from '@angular/forms';
import {routes} from './app.routs';
import { NguCarouselModule } from '@ngu/carousel';
import { MetaModule, MetaLoader, MetaStaticLoader, PageTitlePositioning } from '@ngx-meta/core';

import {TranslationsService} from './services/translations.service';
import {AboutService} from './services/about.service';
import {PoolService} from './services/pool.service';
import {BuildingService} from './services/building.service';
import {RoomsService} from './services/rooms.service';
import {BarAndRestaurantService} from './services/bar-and-restaurant.service';


import { AgmCoreModule } from '@agm/core';

import { AppComponent } from './app.component';
import {PageNotFoundComponent} from './page-not-found-component/page-not-found-component.component';
import { HeaderComponent } from './header/header.component';
import { HomeComponent } from './home/home.component';
import { AboutComponent } from './about/about.component';
import { FeaturesComponent } from './features/features.component';
import { ConstuctUsComponent } from './constuct-us/constuct-us.component';
import { SpecialOfferComponent } from './special-offer/special-offer.component';
import { BarComponent } from './bar/bar.component';
import { RestaurantComponent } from './restaurant/restaurant.component';
import { SwimingPoolComponent } from './swiming-pool/swiming-pool.component';
import { RoomsComponent } from './rooms/rooms.component';
import { FooterComponent } from './footer/footer.component';
import { ConferenceHallComponent } from './conference-hall/conference-hall.component';
import {Config} from './config';
import {SEOService} from './services/seoservice.service';

// export function metaFactory(): MetaLoader {
//   const backendUrl = new Config();
//   return new MetaStaticLoader({
//     pageTitlePositioning: PageTitlePositioning.PrependPageTitle,
//     pageTitleSeparator: ' - ',
//     applicationName: 'Regineh Hotel',
//     defaults: {
//       title: 'Regineh Hotel',
//       description: 'Armenia Regineh Hotel, Hotel with swimming pool, best price booking hotel, Armenian hotel, book hotel',
//       'og:image': './assets/images/logo.png',
//       'og:type': 'website',
//     }
//   });
// }
@NgModule({
  declarations: [
    AppComponent,
    PageNotFoundComponent,
    HeaderComponent,
    HomeComponent,
    AboutComponent,
    FeaturesComponent,
    ConstuctUsComponent,
    SpecialOfferComponent,
    BarComponent,
    RestaurantComponent,
    SwimingPoolComponent,
    RoomsComponent,
    FooterComponent,
    ConferenceHallComponent
  ],
  imports: [
    NguCarouselModule,
    routes,
    MetaModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCdtOgHWEGljVwKLiUv-tZ5wTtSP2uPC_s'
    }),
    HttpModule,
    FormsModule,
    BrowserModule
  ],
  providers: [
    TranslationsService,
    AboutService,
    BarAndRestaurantService,
    RoomsService,
    PoolService,
    SEOService,
    BuildingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/HP Spectre/Desktop/Regineh Hotel/reginehUser/src/app/app.module.ts